import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";
import {
  Box,
  Button,
  Stack,
  Theme,
  useTheme,
  colors,
  Container,
  IconButton,
  Typography,
} from "@mui/material";
import { MdKeyboardArrowRight } from "react-icons/md";
import NextImage from "next/image";
import { extractUrlParams } from "@/global/utils/utils";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { MdClose, MdOutlineKeyboardArrowDown } from "react-icons/md";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export function FilterSelectorFooter(props: {
  onClickNext?: () => void;
  onClickClose?: () => void;
}) {
  return (
    <Stack
      direction={"row"}
      justifyContent={"flex-end"}
      alignItems={"center"}
      spacing={2}
    >
      {props.onClickClose && (
        <ModalActionButton
          onClick={() => props.onClickClose && props.onClickClose()}
          variant="secondary"
        >
          Close
        </ModalActionButton>
      )}
      {props.onClickNext && (
        <ModalActionButton
          variant="primary"
          onClick={() => props.onClickNext && props.onClickNext()}
          endIcon={<MdKeyboardArrowRight />}
        >
          Next
        </ModalActionButton>
      )}
    </Stack>
  );
}

export function MobileFilterDrawerNav(props: { onClickCloseIcon: () => void }) {
  const theme = useTheme();
  const { teamSchema, images } = useTeamConfig();

  return (
    <Container maxWidth="xl">
      <Stack direction={"row"} alignItems={"center"}>
        <Box>
          <Box
            width={`${extractUrlParams(images.logoImage).width}px`}
            height={`${extractUrlParams(images.logoImage).height}px`}
          >
            <NextImage
              onClick={() => {}}
              alt={teamSchema}
              src={images.logoImage}
              width={extractUrlParams(images.logoImage).width}
              height={extractUrlParams(images.logoImage).height}
              style={{
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
        <Box flexGrow={1}></Box>
        <Box>
          <IconButton
            onClick={props?.onClickCloseIcon}
            size="small"
            sx={{
              bgcolor: colors.grey[100],
              borderRadius: 0.7,
            }}
          >
            <CloseRoundedIcon />
          </IconButton>
        </Box>
      </Stack>
    </Container>
  );
}
